module.exports = "/_next/static/images/a739345903aba81cf781a6ba15871540-woman-holding-card-smiling-2@mobile320.png.webp";